import React, { Component } from 'react'
import { connect } from 'react-redux'
import { showModal, closeModal } from '../../actions/modal'

class Modal extends Component {

    closeModal(e) {
        //console.log(e.target.classList)
        if ((typeof this.props.modal.closable === "undefined" || this.props.modal.closable === true) && e.target.classList.contains("modal"))
            this.props.close();
    }

    componentWillUpdate() {
        document.body.classList.toggle("modal-open", !this.props.modal);
    }

    render() {
        const { size, modal } = this.props;
        return modal && (
            <React.Fragment>
                <div onClick={(e) => !modal.loading && this.closeModal(e)} className="modal fade show" style={{ display: 'block' }}>
                    <div className={`modal-dialog modal-${size || 'md'}`}>
                        <div className="modal-content">
                            {modal.title && (
                                <div className="modal-header">
                                    <h4 className="modal-title">{modal.title}</h4>
                                </div>
                            )}
                            <div className="modal-body">
                                {modal.loading && (
                                    <div>
                                        <h5 className="text-center">Please wait...</h5>
                                        <div className="progress progress-info active">
                                            <div className="progress-bar progress-bar-info progress-bar-striped progress-bar-animated" style={{ width: '100%' }}></div>
                                        </div>
                                    </div>
                                )}
                                {!modal.loading && (
                                    <h4 className={`text-center mt-2 mb-2 ${modal.error ? 'alert alert-danger' : ''}`}>{modal.body}</h4>
                                )}
                            </div>
                            {modal.buttons ? (
                                <div className="modal-footer">
                                    {modal.buttons.map((btn, idx) => (
                                        <button key={idx} onClick={() => btn.role === 'cancel' ? this.props.close() : (btn.onClick || null)} type="button" className={`btn btn-${btn.color || 'default'}`}>{btn.label}</button>
                                    ))}
                                </div>
                            ) : !modal.loading && (
                                    <div className="modal-footer">
                                        <button onClick={this.props.close} type="button" className={`btn btn-info}`}>OK</button>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop show"></div>
            </React.Fragment>
        )
    }

}

const mapStateToProps = ({ modal }) => {
    return {
        modal: modal.modal,
        size: modal.size
    }
}

const mapDispatchToProps = dispatch => {
    return {
        showModal: (modal) => dispatch(showModal(modal)),
        close: () => dispatch(closeModal())
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Modal)